





































import Vue from 'vue';
import router from '@/router';
import axios from 'axios';
import {url, client } from '@/util';
import store from '@/store';


import { isLoggedIn, removeToken, loadToken } from './client';

export default Vue.extend({
  data() {
    return {
      isLoggedIn: false,
      isNotLoggedIn: true,
      showDeployment: false,
    }
  },
  methods: {
    LoginCheck(){
      if (this.isLoggedIn == true){
        this.isNotLoggedIn = false;
      } else if (this.isNotLoggedIn == true){
        this.isLoggedIn = false;
      }
    },
    logout() {
       const headers = { "Authorization" : "Bearer " + loadToken()};
       axios.post(url("logout"), null, {headers});
       removeToken();
       client.token = null;
       store.setPermissions({})
       router.replace({path: "/login"})

       this.isLoggedIn = false;
    },
    onLogin() {
      this.LoginCheck();
      this.isLoggedIn = true;
      this.showDeployment = store.getPermission('manage-deployment');
    }
  },
  mounted() {
    this.isLoggedIn = isLoggedIn();
    if (this.isLoggedIn) {
      if (!store.permissionsLoaded()) {
        client.get("/user").then((response) => {
          store.setPermissions(response.data.permissions)
          this.showDeployment = store.getPermission('manage-deployment');
        });
      }
    }
  }
});
